module.exports = __webpack_public_path__ + "static/media/detectDataImage6.4523c2e3.png";